<template>
  <div class="ipr">

    <!-- traka -->
    <div class="ipr-traka">
      <div>
        <div class="ipr-naslov">Izvod {{ izvod.broj || glava.bankStatmentNumber }} · {{ datum(glava.bankStatmentDate) }}</div>
        <div class="ipr-pod">{{ bankaOpis }}</div>
      </div>
      <div class="ipr-razmak"></div>
      <button type="button" class="ipr-b ipr-b-bijeli" @click="natrag">Natrag na popis</button>
      <button type="button" class="ipr-b ipr-b-bijeli" title="Uplate i računi koji čekaju vezu" @click="zaPovezati">Za povezati ▸</button>
      <button type="button" class="ipr-b ipr-b-bijeli" @click="otvoriSve">Sve stavke</button>
      <button type="button" class="ipr-b ipr-b-stari" title="Dosadašnji ekran izvoda (lista stavki gore, knjiženje dolje)" @click="$emit('stari')">Stari način ▸</button>
    </div>

    <div v-if="greska" class="ipr-greska" role="alert">{{ greska }}</div>
    <v-progress-linear v-if="!ucitano && !greska" indeterminate color="primary" class="mb-2"></v-progress-linear>

    <template v-if="ucitano">

      <!-- brojke -->
      <div class="ipr-brojke">
        <div><span>Početno stanje</span><b>{{ fmt(glava.bankStatmentStart) }}</b></div>
        <div><span>Duguje</span><b>{{ fmt(glava.bankStatmentDebit) }}</b></div>
        <div><span>Potražuje</span><b>{{ fmt(glava.bankStatmentCredit) }}</b></div>
        <div><span>Završno stanje</span><b>{{ fmt(glava.bankStatmentFinish) }}</b></div>
        <div :class="provjera.neproknjizeno === 0 ? 'ipr-ok' : 'ipr-lose'"><span>Neproknjiženo</span><b>{{ fmt(provjera.neproknjizeno) }}</b></div>
        <div class="ipr-ok"><span>Spremno</span><b>{{ spremne.length }}</b></div>
        <div :class="brojOdluka === 0 ? 'ipr-ok' : 'ipr-lose'"><span>Traže odluku</span><b>{{ brojOdluka }}</b></div>
      </div>

      <div v-if="provjera.zatvoren" class="ipr-napomena">Izvod je zatvoren. Pregled je samo za uvid.</div>

      <!-- spremno -->
      <div v-if="spremne.length" class="ipr-kartica" :class="{'ipr-sklopljena': !spremnoOtvoreno}">
        <div class="ipr-glava">
          <h2 class="ipr-preklop" @click="spremnoOtvoreno = !spremnoOtvoreno">
            <span class="ipr-strelica">{{ spremnoOtvoreno ? '▾' : '▸' }}</span>Spremno za potvrdu
          </h2>
          <small>isti partner i opis knjiženi na isti konto 3 do 5 i više puta</small>
          <span class="ipr-razmak"></span>
          <button type="button" class="ipr-b ipr-b-zeleni" :disabled="radi || provjera.zatvoren" @click="potvrdiSpremno">
            Potvrdi sve spremno ({{ spremne.length }})
          </button>
        </div>
        <div v-show="spremnoOtvoreno" class="ipr-tijelo">
          <div v-for="s in spremne" :key="s.sideId" class="ipr-red">
            <div class="ipr-ikona" :title="upozorenjaZa(s, s.konto).length ? upozorenjaZa(s, s.konto).map(u => u.tekst).join('\n') : 'Bez upozorenja'">
              {{ upozorenjaZa(s, s.konto).length ? '⚠' : '✓' }}
            </div>
            <div>
              <div class="ipr-partner">{{ s.partner.naziv || '(bez partnera)' }}</div>
              <div class="ipr-opis">{{ s.opis }}</div>
            </div>
            <div class="ipr-iznos" :class="s.strana === 'P' ? 'p' : 'd'">{{ fmt(s.iznos) }}<small>{{ s.strana === 'P' ? 'potražuje' : 'duguje' }}</small></div>
            <div class="ipr-konto">
              {{ s.konto }} {{ s.nazivKonta }}
              <small><span class="ipr-oznaka" :class="s.razina === 'visoka' ? 'visoka' : 'zuta'">{{ s.razina }} · {{ s.slaganje }} od {{ s.odN }}</span>{{ s.razlog }}</small>
            </div>
            <div class="ipr-akcija"><a href="#" title="Prebaci u 'Traže vašu odluku'" @click.prevent="izdvoji(s)">izdvoji</a></div>
          </div>
        </div>
      </div>

      <!-- iznimke -->
      <div v-if="odluka.length || djelomicne.length" class="ipr-kartica">
        <div class="ipr-glava">
          <h2>Traže vašu odluku</h2>
          <small>{{ brojOdluka }} {{ brojOdluka === 1 ? 'stavka' : 'stavki' }} · Enter potvrđuje aktivnu stavku</small>
          <span class="ipr-razmak"></span>
        </div>
        <div class="ipr-tijelo">

          <div
            v-for="s in odluka"
            :key="s.sideId"
            class="ipr-iz"
            :class="{aktivna: aktivna === s.sideId}"
            @keydown.enter.capture="zapamtiMeni(s)"
            @keyup.enter="enter(s, $event)"
          >
            <div class="ipr-vrh" :class="{'ipr-klik': aktivna !== s.sideId}" @click="aktiviraj(s)">
              <span class="ipr-partner-v">{{ s.partner.naziv || 'Bez partnera' }}</span>
              <span class="ipr-opis-v">„{{ s.opis }}“</span>
              <span class="ipr-razmak"></span>
              <span v-if="aktivna !== s.sideId && s.unos" class="ipr-sazetak">konto {{ s.unos }}</span>
              <span class="ipr-iznos" :class="s.strana === 'P' ? 'p' : 'd'" style="font-size:18px">
                {{ fmt(s.iznos) }}<small>{{ s.strana === 'P' ? 'potražuje' : 'duguje' }} · {{ datum(s.datum || glava.bankStatmentDate) }}</small>
              </span>
            </div>

            <template v-if="aktivna === s.sideId">
              <div v-for="(r, i) in razloziOdluke(s, izvod.kontoBanke)" :key="'r' + i" class="ipr-razlog">{{ r }}</div>

              <div class="ipr-brzi">
                <span
                  v-for="z in brziZa(s)"
                  :key="z.konto"
                  class="ipr-zeton"
                  :class="{izabran: s.unos === z.konto}"
                  :title="nazivKonta(z.konto)"
                  @click="izaberi(s, z.konto)"
                >{{ z.naziv }} → {{ z.konto }}</span>
                <span class="ipr-zeton ipr-zeton-sivi" @click="partnerOtvoren = partnerOtvoren === s.sideId ? 0 : s.sideId">
                  {{ partnerOtvoren === s.sideId ? 'Sakrij partnera' : (imaPartnera(s.partner) ? 'Promijeni partnera' : 'Dodijeli partnera') }}
                </span>
                <span class="ipr-zeton ipr-zeton-sivi" title="Otvara unos partnera; po spremanju se vratite (strelica natrag) na ovaj izvod" @click="noviPartner">+ Novi partner</span>
              </div>

              <div class="ipr-forma">
                <div class="ipr-polje">
                  <label>Konto</label>
                  <v-autocomplete
                    :ref="'konto' + s.sideId"
                    v-model="s.unos"
                    :items="konta"
                    item-value="account4"
                    :item-text="kontoTekst"
                    dense hide-details outlined clearable
                    placeholder="odaberite konto"
                    @change="promijenjen(s)"
                  ></v-autocomplete>
                </div>
                <div class="ipr-polje">
                  <label>Iznos</label>
                  <input :value="fmt(s.iznos)" readonly>
                </div>
                <div class="ipr-polje">
                  <label>Partner</label>
                  <div class="ipr-partner-pregled">
                    <b>{{ s.partner.naziv || '(bez partnera)' }}</b>
                    <small v-if="s.partner.oib">OIB {{ s.partner.oib }}</small>
                    <small v-else-if="imaPartnera(s.partner)">bez OIB-a (privatna osoba)</small>
                    <small v-if="s.partner.iban">IBAN {{ s.partner.iban }}</small>
                    <small v-if="adresa(s)">{{ adresa(s) }}</small>
                  </div>
                </div>
              </div>

              <div v-if="partnerOtvoren === s.sideId" class="ipr-partner-panel">
                <v-autocomplete
                  v-model="odabraniPartner"
                  :items="partnerStavke"
                  :search-input.sync="partnerTrazi"
                  item-text="tekst"
                  item-value="id"
                  return-object
                  no-filter
                  clearable dense hide-details outlined
                  label="Traži partnera po nazivu ili OIB-u (najmanje 2 slova)"
                  no-data-text="Partner nije pronađen u šifrarniku"
                  @change="dodijeliPartnera(s)"
                ></v-autocomplete>
                <small class="ipr-uputa">Partner se upisuje na stavku izvoda, a ne u šifrarnik. Privatna osoba bez OIB-a: odaberite je iz šifrarnika ili je dodajte s “+ Novi partner”.</small>
              </div>

              <div v-for="(u, i) in upozorenjaZa(s, s.unos)" :key="'u' + i" class="ipr-razlog" :class="{crveno: u.razina === 'greska'}">{{ u.tekst }}</div>

              <div class="ipr-radnje">
                <template v-if="trebaStari(s)">
                  <button type="button" class="ipr-b ipr-b-obrub" @click="otvoriUStarom(s.sideId)">Otvori u starom ekranu</button>
                  <span class="ipr-preostalo">stavka se knjiži u starom ekranu (strana valuta ili bez jasnog smjera)</span>
                </template>
                <template v-else>
                  <button type="button" class="ipr-b ipr-b-zeleni" :disabled="radi || !s.unos || provjera.zatvoren" @click="potvrdiJednu(s)">Potvrdi i sljedeća ⏎</button>
                  <button type="button" class="ipr-b ipr-b-sivi" @click="preskoci(s)">Preskoči</button>
                  <button type="button" class="ipr-b ipr-b-sivi" title="Razdioba na više konta i sl." @click="otvoriUStarom(s.sideId)">Otvori u starom ekranu</button>
                  <span class="ipr-preostalo">preostalo za rasporediti: <b>{{ s.unos ? '0,00' : fmt(s.iznos) }}</b></span>
                </template>
              </div>
            </template>
          </div>

          <!-- djelomicno proknjizene -->
          <div v-for="d in djelomicne" :key="'dj' + d.id" class="ipr-iz">
            <div class="ipr-vrh">
              <span class="ipr-partner-v">{{ d.partnerName || 'Bez partnera' }}</span>
              <span class="ipr-opis-v">stavka {{ d.rbr }}</span>
              <span class="ipr-razmak"></span>
              <button type="button" class="ipr-b ipr-b-obrub" @click="otvoriUStarom(d.id)">Otvori u starom ekranu</button>
            </div>
            <div class="ipr-razlog">Djelomično proknjižena stavka: dovršite je u starom ekranu.</div>
          </div>
        </div>
      </div>

      <div v-if="!spremne.length && !odluka.length && !djelomicne.length" class="ipr-kartica">
        <div class="ipr-prazno">Na ovom izvodu nema neproknjiženih stavki.</div>
      </div>

      <!-- provjere -->
      <div class="ipr-kartica">
        <div class="ipr-glava"><h2>Provjere prije zatvaranja izvoda</h2></div>
        <div class="ipr-provjere">
          <div v-for="(p, i) in provjera.stavke" :key="i" :class="p.ok ? 'pv-ok' : 'pv-cekanje'">{{ p.tekst }}</div>
        </div>
      </div>

      <!-- sve stavke -->
      <div ref="sve" class="ipr-kartica" :class="{'ipr-sklopljena': !sveOtvoreno}">
        <div class="ipr-glava">
          <h2 class="ipr-preklop" @click="sveOtvoreno = !sveOtvoreno">
            <span class="ipr-strelica">{{ sveOtvoreno ? '▾' : '▸' }}</span>Sve stavke izvoda ({{ sides.length }})
          </h2>
          <small>pregled po stavkama; “Otvori” vodi u dosadašnji ekran knjiženja te stavke</small>
        </div>
        <div v-show="sveOtvoreno" class="ipr-scroll">
          <table class="ipr-tbl">
            <thead><tr>
              <th>R.br.</th><th>Status</th><th>Partner i opis</th><th class="d">Duguje</th><th class="d">Potražuje</th><th></th>
            </tr></thead>
            <tbody>
              <tr v-for="x in sides" :key="x.id">
                <td>{{ x.bankStatmentNumberDetail }}</td>
                <td><span class="ipr-oznaka" :class="statusKlasa(x)">{{ statusStavke(x) }}</span></td>
                <td class="opis"><b>{{ x.partnerName || '(bez partnera)' }}</b><small>{{ x.bankDescription }}</small></td>
                <td class="d">{{ brojIliCrta(x.bankStatmentDebit) }}</td>
                <td class="d">{{ brojIliCrta(x.bankStatmentCredit) }}</td>
                <td class="d"><a href="#" @click.prevent="otvoriUStarom(x.id)">Otvori</a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </template>

    <!-- donja traka -->
    <div v-if="ucitano" class="ipr-donja">
      <div class="ipr-stanje">
        Proknjiženo {{ proknjizeno }} od {{ sides.length }} · neproknjiženo {{ fmt(provjera.neproknjizeno) }}
      </div>
      <button
        type="button"
        class="ipr-b ipr-b-zeleni"
        :disabled="!provjera.mozeZatvoriti || radi"
        :title="provjera.zatvoren ? 'Izvod je već zatvoren' : (provjera.mozeZatvoriti ? '' : 'Moguće tek kad je neproknjiženo 0,00 i konto banke postavljen')"
        @click="zatvoriIzvod"
      >{{ provjera.zatvoren ? 'Izvod zatvoren' : 'Zatvori izvod' }}</button>
    </div>

    <v-snackbar v-model="snackbar" :color="snackBoja" :timeout="5000" bottom>{{ snackTekst }}</v-snackbar>
  </div>
</template>

<script>
// Pregled iznimki izvoda: pocetni prikaz izvoda. Server racuna prijedlog (GET, samo
// citanje); ovdje se stavke razvrstaju na "spremno" i "trazi odluku". Stvarni retci
// glavne knjige nastaju tek kad korisnik potvrdi (POST potvrdi), stavku po stavku ili
// skupno. Dosadasnji ekran (stavke gore, knjizenje dolje) ostaje kao "Stari nacin".
//
// Logika upozorenja, razvrstavanja i provjera je u izvodPregled.js (ima test).

import MainLedgerIzvodKnjizenjeService from '@/services/MainLedgerIzvodKnjizenjeService'
import MainLedgerService from '@/services/MainLedgerService'
import MainLedgerDetailService from '@/services/MainLedgerDetailService'
import dateFormat from '@/snippets/dateFormat'
import {
  fmt, imaPartnera, trebaStariEkran, upozorenjaKonta, blokira, brziKonta, razvrstaj, razloziOdluke, provjere, n2
} from './izvodPregled'

const poruka = (err) => {
  if (err && err.response && err.response.data && err.response.data.error) { return err.response.data.error }
  return err && err.message ? err.message : String(err)
}

export default {
  name: 'MainLedgerIzvodPregled',
  data () {
    return {
      ucitano: false,
      greska: '',
      glava: {},
      izvod: {},
      stavke: [],
      sides: [],
      konta: [],
      djelomicneId: [],
      unosi: {},
      izdvojene: {},
      aktivna: 0,
      meniBio: false,
      radi: false,
      spremnoOtvoreno: true,
      sveOtvoreno: false,
      partnerOtvoren: 0,
      partnerTrazi: '',
      odabraniPartner: null,
      snackbar: false,
      snackTekst: '',
      snackBoja: 'green'
    }
  },
  computed: {
    CompanyId () { return this.$store.state.companyid },
    MainLedgerId () { return this.$store.state.mainledgerid },
    planMapa () {
      const m = {}
      this.konta.forEach(k => { m[k.account4] = true })
      return m
    },
    razvrstano () {
      const {spremne} = razvrstaj(this.stavke)
      const dobre = {}
      spremne.forEach(s => {
        if (!this.izdvojene[s.sideId] && !blokira(this.upozorenjaZa(s, s.konto))) { dobre[s.sideId] = true }
      })
      return {
        spremne: this.stavke.filter(s => dobre[s.sideId]),
        odluka: this.stavke.filter(s => !dobre[s.sideId])
      }
    },
    spremne () { return this.razvrstano.spremne },
    odluka () { return this.razvrstano.odluka },
    djelomicne () {
      return this.sides
        .filter(x => x.ClosedAccount !== true && !this.stavke.some(s => s.sideId === x.id))
        .map(x => ({id: x.id, rbr: x.bankStatmentNumberDetail, partnerName: x.partnerName}))
    },
    brojOdluka () { return this.odluka.length + this.djelomicne.length },
    provjera () {
      return provjere({glava: this.glava, sides: this.sides, kontoBanke: this.izvod.kontoBanke})
    },
    proknjizeno () { return this.sides.filter(x => x.ClosedAccount === true).length },
    bankaOpis () {
      const banka = this.$store.state.bankActiv && this.$store.state.bankActiv.BankName ? this.$store.state.bankActiv.BankName : ''
      const iban = this.glava.bankAccountNr || ''
      return [banka, iban, this.glava.bankStatmentMoneyName || this.izvod.valuta].filter(x => x).join(' · ')
    },
    // Samo partneri koji odgovaraju upisanom tekstu; cijeli sifrarnik ima i 18.000 redaka.
    partnerStavke () {
      const lista = this.$store.state.partnerStore || []
      const q = String(this.partnerTrazi || '').trim().toLowerCase()
      if (q.length < 2) { return this.odabraniPartner ? [this.odabraniPartner] : [] }
      const rez = []
      for (let i = 0; i < lista.length && rez.length < 40; i++) {
        const p = lista[i]
        const naziv = String(p.partnerName || '')
        const oib = String(p.partnerVATID || '').trim()
        if (naziv.toLowerCase().indexOf(q) >= 0 || (oib && oib.indexOf(q) >= 0)) {
          rez.push({id: p.id, partnerName: naziv, partnerVATID: oib, tekst: naziv + ' · ' + (oib || 'bez OIB-a')})
        }
      }
      return rez
    }
  },
  mounted () {
    this.ucitaj()
  },
  methods: {
    fmt,
    imaPartnera,
    razloziOdluke,
    datum (d) { return d ? dateFormat(d) : '' },
    brojIliCrta (v) { return n2(v) === 0 ? '—' : fmt(v) },
    kontoTekst (k) { return k.account4 + ' ' + (k.naziv || '') },
    trebaStari (s) { return trebaStariEkran(s) },
    adresa (s) {
      const x = this.sides.find(z => z.id === s.sideId) || {}
      return [[x.partnerStreet, x.partnerBuildingNameNumber].filter(a => a).join(' '), [x.partnerPostcode, x.partnerCity].filter(a => a).join(' ')]
        .filter(a => a).join(', ')
    },
    statusStavke (x) {
      if (x.ClosedAccount === true) { return 'proknjiženo' }
      if (this.djelomicne.some(d => d.id === x.id)) { return 'djelomično' }
      return 'neproknjiženo'
    },
    statusKlasa (x) {
      return x.ClosedAccount === true ? 'visoka' : 'zuta'
    },
    javi (tekst, boja) {
      this.snackTekst = tekst
      this.snackBoja = boja || 'green'
      this.snackbar = true
    },
    upozorenjaZa (s, konto) {
      return upozorenjaKonta({
        konto, smjer: s.smjer, iznos: s.iznos, opis: s.opis, partner: s.partner,
        kontoBanke: this.izvod.kontoBanke, plan: this.planMapa
      })
    },
    brziZa (s) {
      return brziKonta({
        smjer: s.smjer, opis: s.opis, savjet: s.konto, kandidati: s.kandidati,
        postoji: (k) => !!this.planMapa[k]
      })
    },
    nazivKonta (konto) {
      const k = this.konta.find(x => x.account4 === konto)
      return k && k.naziv ? konto + ' ' + k.naziv : konto
    },
    async ucitaj () {
      this.greska = ''
      try {
        const [pr, gl, st] = await Promise.all([
          MainLedgerIzvodKnjizenjeService.prijedlog({CompanyId: this.CompanyId, MainLedgerId: this.MainLedgerId}),
          MainLedgerService.show(this.MainLedgerId),
          MainLedgerService.indexbsdetails({CompanyId: this.CompanyId, databaseMLID: this.MainLedgerId})
        ])
        const data = pr.data
        this.izvod = {...data.izvod, vecProknjizeno: data.vecProknjizeno}
        this.konta = data.konta || []
        this.glava = gl.data.mainLedger || {}
        this.sides = st.data.mainledgerDetails || []
        // `unos` je konto koji korisnik vidi i mijenja; `konto` ostaje onaj sto je predlozio server.
        this.stavke = (data.stavke || []).map(s => ({
          ...s,
          unos: this.unosi[s.sideId] !== undefined ? this.unosi[s.sideId] : (s.konto || null)
        }))
        await this.$store.dispatch('setMainLedgerActiv', this.glava)
        if (!this.odluka.some(s => s.sideId === this.aktivna)) {
          this.aktivna = this.odluka.length ? this.odluka[0].sideId : 0
        }
      } catch (err) {
        this.greska = 'Pregled nije učitan: ' + poruka(err)
      }
      this.ucitano = true
    },
    // Glava i retci izvoda u storeu moraju pokazati ono sto je upravo upisano
    // (stari nacin ih cita odande).
    async osvjeziStore () {
      try {
        const retci = (await MainLedgerDetailService.index(this.MainLedgerId)).data.mainledgerDetails
        await this.$store.dispatch('setMainLedgerItems', retci || [])
      } catch (err) {
        // store se osvjezi pri sljedecem otvaranju izvoda; knjizenje je vec spremljeno
      }
    },
    aktiviraj (s) {
      if (this.aktivna !== s.sideId) {
        this.aktivna = s.sideId
        this.partnerOtvoren = 0
        this.odabraniPartner = null
        this.partnerTrazi = ''
      }
    },
    izaberi (s, konto) {
      s.unos = konto
      this.promijenjen(s)
    },
    promijenjen (s) {
      this.$set(this.unosi, s.sideId, s.unos || null)
    },
    izdvoji (s) {
      this.$set(this.izdvojene, s.sideId, true)
      this.aktivna = s.sideId
    },
    preskoci (s) {
      const lista = this.odluka
      const i = lista.findIndex(x => x.sideId === s.sideId)
      const sljedeca = lista[(i + 1) % lista.length]
      if (sljedeca) { this.aktivna = sljedeca.sideId }
    },
    // Enter u polju konta bira stavku iz izbornika; potvrda stavke tek na sljedeci Enter.
    zapamtiMeni (s) {
      const ref = this.$refs['konto' + s.sideId]
      const komp = Array.isArray(ref) ? ref[0] : ref
      this.meniBio = !!(komp && komp.isMenuActive)
    },
    enter (s, ev) {
      const meta = ev && ev.target && ev.target.tagName
      if (meta === 'BUTTON' || meta === 'A' || this.aktivna !== s.sideId) { return }
      if (this.meniBio) { this.meniBio = false; return }
      if (!s.unos || this.trebaStari(s)) { return }
      this.potvrdiJednu(s)
    },
    otvoriSve () {
      this.sveOtvoreno = true
      this.$nextTick(() => { if (this.$refs.sve && this.$refs.sve.scrollIntoView) { this.$refs.sve.scrollIntoView({behavior: 'smooth', block: 'start'}) } })
    },
    natrag () {
      this.$store.dispatch('setMainLedgerStatus', 1)
      this.$router.push({name: 'mainledger4'})
    },
    zaPovezati () {
      this.$router.push({name: 'mainledgerzapovezati'})
    },
    noviPartner () {
      this.$store.dispatch('seteditItem', 0)
      this.$router.push({name: 'partnercreate'})
    },
    // Isto sto radi klik na red u starom ekranu izvoda.
    async otvoriUStarom (sideId) {
      const side = this.sides.find(x => x.id === sideId)
      if (!side) { return }
      if (side.ClosedAccount && !window.confirm('Odabrali ste stavku koja je već proknjižena. Da li ste sigurni?')) { return }
      this.$store.dispatch('setMainLedgerSideItem', side)
      this.$store.dispatch('setConnId', side.id)
      this.$store.dispatch('setConnName', this.$store.state.mainledgerActiv.documentIdGeneral ? this.$store.state.mainledgerActiv.documentIdGeneral : null)
      this.$store.dispatch('seteditItem', 0)
      this.$router.push({name: 'mainledgerdetailcreate'})
    },
    async dodijeliPartnera (s) {
      const p = this.odabraniPartner
      if (!p || this.radi) { return }
      this.radi = true
      try {
        await MainLedgerIzvodKnjizenjeService.dodijeliPartnera({
          CompanyId: this.CompanyId, MainLedgerId: this.MainLedgerId, sideId: s.sideId,
          partnerId: p.id, partnerVATID: p.partnerVATID
        })
        this.odabraniPartner = null
        this.partnerTrazi = ''
        this.partnerOtvoren = 0
        const prije = s.sideId
        await this.ucitaj()
        const i = this.spremne.some(x => x.sideId === prije)
        this.javi(i ? 'Partner dodijeljen; stavka je sada u "Spremno za potvrdu".' : 'Partner dodijeljen stavci.')
      } catch (err) {
        this.javi('Partner nije dodijeljen: ' + poruka(err), 'red')
      }
      this.radi = false
    },
    async potvrdiJednu (s) {
      if (this.radi || !s.unos) { return }
      const uz = this.upozorenjaZa(s, s.unos)
      if (blokira(uz)) {
        this.javi(uz.filter(u => u.razina === 'greska').map(u => u.tekst).join(' '), 'red')
        return
      }
      const upoz = uz.filter(u => u.razina === 'upozorenje')
      if (upoz.length && !window.confirm('Provjerite prije knjiženja:\n\n' + upoz.map(u => '• ' + u.tekst).join('\n') +
        '\n\nProknjižiti ' + fmt(s.iznos) + ' (' + (s.strana === 'P' ? 'potražuje' : 'duguje') + ') na konto ' + s.unos + '?')) {
        return
      }
      const lista = this.odluka
      const i = lista.findIndex(x => x.sideId === s.sideId)
      const sljedeca = lista[i + 1] || lista[0]
      const sljedecaId = sljedeca && sljedeca.sideId !== s.sideId ? sljedeca.sideId : 0
      this.radi = true
      try {
        const {data} = await MainLedgerIzvodKnjizenjeService.potvrdi({
          CompanyId: this.CompanyId, MainLedgerId: this.MainLedgerId,
          stavke: [{sideId: s.sideId, konto: s.unos}]
        })
        if (!(data.proknjizeno || []).length) {
          const razlog = (data.preskoceno || []).map(p => p.razlog).join(' ') || 'Stavka nije proknjižena.'
          this.javi(razlog, 'red')
        } else {
          const iz = data.izvod || {}
          this.javi(iz.upozorenje || (iz.proknjizen ? 'Stavka proknjižena. Izvod je zatvoren.' : 'Stavka proknjižena.'), iz.upozorenje ? 'orange' : 'green')
          this.$delete(this.unosi, s.sideId)
          this.aktivna = sljedecaId
        }
        await this.osvjeziStore()
        await this.ucitaj()
        this.$emit('promijenjeno')
      } catch (err) {
        this.javi('Knjiženje nije izvršeno: ' + poruka(err), 'red')
      }
      this.radi = false
    },
    async potvrdiSpremno () {
      const lista = this.spremne.slice()
      if (!lista.length || this.radi) { return }
      const zbroj = lista.reduce((a, s) => a + s.iznos, 0)
      const velike = lista.filter(s => s.iznos >= 5000).length
      const bezPartnera = lista.filter(s => !imaPartnera(s.partner)).length
      const poruka1 = 'Proknjižiti ' + lista.length + ' stavki (zbroj ' + fmt(zbroj) + ') prema prijedlogu konta?' +
        (velike ? '\n\nOd toga ' + velike + ' u iznosu od 5.000,00 ili više.' : '') +
        (bezPartnera ? '\n' + bezPartnera + ' bez partnera na stavci.' : '')
      if (!window.confirm(poruka1)) { return }
      this.radi = true
      try {
        const {data} = await MainLedgerIzvodKnjizenjeService.potvrdi({
          CompanyId: this.CompanyId, MainLedgerId: this.MainLedgerId,
          stavke: lista.map(s => ({sideId: s.sideId, konto: s.konto}))
        })
        const n = (data.proknjizeno || []).length
        const preskoceno = data.preskoceno || []
        const iz = data.izvod || {}
        this.javi('Proknjiženo ' + n + (preskoceno.length ? ', preskočeno ' + preskoceno.length + ': ' + preskoceno.map(p => p.razlog).join(' ') : '') +
          (iz.upozorenje ? ' ' + iz.upozorenje : (iz.proknjizen ? ' Izvod je zatvoren.' : '')), preskoceno.length || iz.upozorenje ? 'orange' : 'green')
        await this.osvjeziStore()
        await this.ucitaj()
        this.$emit('promijenjeno')
      } catch (err) {
        this.javi('Knjiženje nije izvršeno: ' + poruka(err), 'red')
      }
      this.radi = false
    },
    async zatvoriIzvod () {
      if (!this.provjera.mozeZatvoriti || this.radi) { return }
      if (!window.confirm('Zatvoriti izvod? Dodaje se zbirni redak banke (' + this.izvod.kontoBanke + ') i izvod se označava kao proknjižen.')) { return }
      this.radi = true
      try {
        const {data} = await MainLedgerIzvodKnjizenjeService.potvrdi({
          CompanyId: this.CompanyId, MainLedgerId: this.MainLedgerId, dovrsi: true, stavke: []
        })
        const iz = data.izvod || {}
        if (iz.upozorenje) { this.javi(iz.upozorenje, 'orange') } else if (iz.proknjizen) { this.javi('Izvod je zatvoren.') } else {
          this.javi('Izvod nije zatvoren: razlika duguje/potražuje je ' + fmt(iz.DiffTotal) + '.', 'red')
        }
        await this.osvjeziStore()
        await this.ucitaj()
        this.$emit('promijenjeno')
      } catch (err) {
        this.javi('Izvod nije zatvoren: ' + poruka(err), 'red')
      }
      this.radi = false
    }
  }
}
</script>

<style scoped>
.ipr { --plava: #1976d2; --plava-tamna: #1565c0; --plava-svijetla: #eef4fb; --crta: rgba(0,0,0,.12); --sivo: rgba(0,0,0,.6);
  --zelena: #2e7d32; --zelena-sv: #e8f5e9; --zuta: #b26a00; --zuta-sv: #fff4e0; --crvena: #c62828; --crvena-sv: #fdecea;
  max-width: 1100px; margin: 0 auto; padding: 4px 0 70px; font-size: 15px; }
.ipr-razmak { flex: 1; }
.ipr-traka { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; background: var(--plava); color: #fff; border-radius: 4px; padding: 10px 14px; margin-bottom: 10px; }
.ipr-naslov { font-size: 20px; font-weight: 700; line-height: 1.2; }
.ipr-pod { font-size: 13px; opacity: .9; margin-top: 2px; }
.ipr-b { font-family: inherit; font-size: 14px; font-weight: 500; border-radius: 4px; padding: 7px 14px; cursor: pointer; border: 1px solid transparent; }
.ipr-b-bijeli { background: #fff; color: var(--plava); }
.ipr-b-stari { background: transparent; color: #fff; border-color: rgba(255,255,255,.6); }
.ipr-b-zeleni { background: #43a047; color: #fff; }
.ipr-b-zeleni[disabled] { background: #b7d9b9; cursor: not-allowed; }
.ipr-b-obrub { background: #fff; color: var(--plava); border-color: var(--plava); }
.ipr-b-sivi { background: #fff; color: var(--sivo); border-color: var(--crta); }
.ipr-greska { margin: 8px 0; padding: 8px 12px; border: 1px solid #e0b4a8; background: #fbeeea; color: #8c2f1e; }
.ipr-napomena { margin: 0 0 10px; padding: 8px 12px; background: var(--plava-svijetla); border: 1px solid #c7d6e6; font-size: 14px; }

.ipr-brojke { display: flex; flex-wrap: wrap; gap: 14px 26px; background: #fff; border: 1px solid var(--crta); border-radius: 4px; padding: 10px 16px; margin-bottom: 10px; }
.ipr-brojke span { display: block; font-size: 12px; color: var(--sivo); line-height: 1.2; }
.ipr-brojke b { font-size: 19px; font-variant-numeric: tabular-nums; }
.ipr-brojke .ipr-ok b { color: var(--zelena); }
.ipr-brojke .ipr-lose b { color: var(--crvena); }

.ipr-kartica { background: #fff; border: 1px solid var(--crta); border-radius: 4px; margin-bottom: 10px; overflow: hidden; }
.ipr-glava { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; background: var(--plava-svijetla); border-bottom: 2px solid var(--plava); padding: 8px 14px; }
.ipr-glava h2 { margin: 0; font-size: 16px; color: var(--plava-tamna); font-weight: 700; }
.ipr-glava small { color: var(--sivo); }
.ipr-preklop { cursor: pointer; user-select: none; }
.ipr-strelica { display: inline-block; width: 18px; }
.ipr-sklopljena .ipr-glava { border-bottom-color: transparent; }

.ipr-red { display: grid; grid-template-columns: 30px 1.6fr 110px 1.6fr 60px; gap: 10px; align-items: center; padding: 8px 14px; border-top: 1px solid var(--crta); }
.ipr-red:first-child { border-top: 0; }
.ipr-ikona { text-align: center; color: var(--zelena); font-weight: 700; cursor: default; }
.ipr-partner { font-weight: 500; }
.ipr-opis { font-size: 13px; color: var(--sivo); }
.ipr-iznos { text-align: right; font-weight: 700; font-variant-numeric: tabular-nums; }
.ipr-iznos.p { color: var(--zelena); }
.ipr-iznos.d { color: var(--crvena); }
.ipr-iznos small { display: block; font-weight: 400; color: var(--sivo); font-size: 12px; }
.ipr-konto { font-size: 14px; }
.ipr-konto small { display: block; color: var(--sivo); font-size: 12px; }
.ipr-akcija { text-align: right; font-size: 13px; }
.ipr-oznaka { display: inline-block; font-size: 12px; border-radius: 10px; padding: 1px 9px; margin-right: 4px; }
.ipr-oznaka.visoka { background: var(--zelena-sv); color: var(--zelena); }
.ipr-oznaka.zuta { background: var(--zuta-sv); color: var(--zuta); }

.ipr-iz { border-top: 1px solid var(--crta); padding: 12px 14px; }
.ipr-iz:first-child { border-top: 0; }
.ipr-iz.aktivna { background: #fbfdff; box-shadow: inset 4px 0 0 var(--plava); }
.ipr-vrh { display: flex; gap: 14px; align-items: baseline; flex-wrap: wrap; }
.ipr-klik { cursor: pointer; }
.ipr-partner-v { font-weight: 700; font-size: 16px; }
.ipr-opis-v { color: var(--sivo); font-size: 14px; }
.ipr-sazetak { font-size: 13px; color: var(--plava-tamna); }
.ipr-razlog { margin: 6px 0; font-size: 13px; color: var(--zuta); background: var(--zuta-sv); border-radius: 4px; padding: 5px 10px; }
.ipr-razlog.crveno { color: var(--crvena); background: var(--crvena-sv); }
.ipr-brzi { display: flex; flex-wrap: wrap; gap: 6px; margin: 8px 0; }
.ipr-zeton { border: 1px solid var(--plava); color: var(--plava); background: #fff; border-radius: 16px; padding: 4px 12px; font-size: 13px; cursor: pointer; user-select: none; }
.ipr-zeton.izabran { background: var(--plava); color: #fff; }
.ipr-zeton-sivi { border-color: var(--crta); color: var(--sivo); }
.ipr-forma { display: grid; grid-template-columns: 2fr 1fr 2fr; gap: 12px; margin-top: 6px; }
.ipr-polje label { display: block; font-size: 12px; color: var(--sivo); }
.ipr-polje input { width: 100%; padding: 8px; font: inherit; border: 1px solid var(--crta); border-radius: 4px; background: #f7f7f7; }
.ipr-partner-pregled { font-size: 14px; line-height: 1.35; padding-top: 2px; }
.ipr-partner-pregled small { display: block; color: var(--sivo); font-size: 12px; }
.ipr-partner-panel { margin-top: 10px; padding: 10px; background: var(--plava-svijetla); border-radius: 4px; }
.ipr-uputa { display: block; margin-top: 6px; color: var(--sivo); font-size: 12px; }
.ipr-radnje { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; align-items: center; }
.ipr-preostalo { margin-left: auto; font-size: 13px; color: var(--sivo); }
.ipr-preostalo b { font-variant-numeric: tabular-nums; }
.ipr-prazno { padding: 24px; text-align: center; color: var(--sivo); }

.ipr-provjere { padding: 8px 14px; font-size: 14px; }
.ipr-provjere div { padding: 3px 0; }
.pv-ok::before { content: "✓ "; color: var(--zelena); font-weight: 700; }
.pv-cekanje::before { content: "○ "; color: var(--zuta); font-weight: 700; }

.ipr-scroll { overflow-x: auto; }
.ipr-tbl { width: 100%; border-collapse: collapse; font-size: 14px; }
.ipr-tbl th { text-align: left; font-weight: 600; padding: 6px 10px; border-bottom: 1px solid var(--crta); color: var(--sivo); white-space: nowrap; }
.ipr-tbl td { padding: 5px 10px; border-bottom: 1px solid #eee; vertical-align: top; }
.ipr-tbl .d { text-align: right; white-space: nowrap; font-variant-numeric: tabular-nums; }
.ipr-tbl td.opis small { display: block; color: var(--sivo); font-size: 12px; }

.ipr-donja { position: sticky; bottom: 0; background: #fff; border-top: 2px solid var(--plava); padding: 10px 16px; display: flex; gap: 12px; align-items: center; justify-content: center; flex-wrap: wrap; z-index: 2; }
.ipr-stanje { font-size: 14px; }

@media (max-width: 760px) {
  .ipr-red { grid-template-columns: 24px 1fr 90px; }
  .ipr-red .ipr-konto, .ipr-red .ipr-akcija { grid-column: 2 / 4; text-align: left; }
  .ipr-forma { grid-template-columns: 1fr; }
  .ipr-preostalo { margin-left: 0; width: 100%; }
}
</style>
